import { render, staticRenderFns } from "./RegionsToSelect.vue?vue&type=template&id=4d9e01a0&scoped=true"
import script from "./RegionsToSelect.vue?vue&type=script&lang=js"
export * from "./RegionsToSelect.vue?vue&type=script&lang=js"
import style0 from "./RegionsToSelect.vue?vue&type=style&index=0&id=4d9e01a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9e01a0",
  null
  
)

export default component.exports